export class News {
  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
  }

  init(): void {
    // Legacy module was a no-op stub — preserved for component registration
  }

  destroy(): void {}

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="news"]')
      .forEach((el) => {
        new News(el).init();
      });
  }
}
